module.exports = __webpack_public_path__ + "static/img/fast-seller-badge-disabled.19ae1168.svg";